import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "search-box mb-4"
};
const _hoisted_2 = {
  class: "franchisee-list max-h-80 overflow-y-auto border border-slate-200 rounded-lg"
};
const _hoisted_3 = {
  key: 0,
  class: "p-4 text-center text-slate-500"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "flex items-center gap-3"
};
const _hoisted_6 = {
  class: "flex-1"
};
const _hoisted_7 = {
  class: "font-medium text-slate-800"
};
const _hoisted_8 = {
  class: "text-xs text-slate-500 mt-0.5"
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  key: 1,
  class: "ml-2"
};
const _hoisted_11 = {
  key: 2,
  class: "p-8 text-center text-slate-500"
};
const _hoisted_12 = {
  class: "flex items-center justify-between"
};
const _hoisted_13 = {
  class: "text-sm text-slate-500"
};
const _hoisted_14 = {
  class: "font-medium text-primary-600"
};
const _hoisted_15 = {
  class: "flex items-center gap-2"
};
import { ref, computed, watch } from 'vue';
import { getFranchiseePage } from '@/api/franchisee';
export default {
  __name: 'FranchiseePicker',
  props: {
    modelValue: {
      type: [Array, String, Number],
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const dialogVisible = ref(false);
    const loading = ref(false);
    const searchKeyword = ref('');
    const franchiseeList = ref([]);
    const selectedList = computed(() => {
      if (!props.modelValue) return [];
      return Array.isArray(props.modelValue) ? props.modelValue : [props.modelValue];
    });
    const isSelected = item => {
      return selectedList.value.some(s => typeof s === 'object' && s.id === item.id || s === item.id || s === String(item.id));
    };
    const toggleSelect = item => {
      const current = [...selectedList.value];
      const index = current.findIndex(s => typeof s === 'object' && s.id === item.id || s === item.id || s === String(item.id));
      if (props.multiple) {
        if (index > -1) {
          current.splice(index, 1);
        } else {
          current.push({
            id: item.id,
            name: item.name
          });
        }
      } else {
        if (index > -1) {
          current.length = 0;
        } else {
          current.length = 0;
          current.push({
            id: item.id,
            name: item.name
          });
        }
      }
      emit('update:modelValue', props.multiple ? current : current[0] || null);
    };
    const handleSearch = async () => {
      await loadFranchisees();
    };
    const loadFranchisees = async () => {
      try {
        loading.value = true;
        const res = await getFranchiseePage({
          name: searchKeyword.value || undefined,
          status: 3,
          // 只查询正式加盟商
          current: 1,
          size: 100
        });
        franchiseeList.value = res.records || [];
      } catch (error) {
        console.error('加载加盟商列表失败:', error);
      } finally {
        loading.value = false;
      }
    };
    const handleConfirm = () => {
      emit('update:modelValue', props.multiple ? selectedList.value : selectedList.value[0] || null);
      dialogVisible.value = false;
    };

    // 打开弹窗时加载数据
    watch(dialogVisible, val => {
      if (val) {
        loadFranchisees();
      }
    });

    // 提供打开选择器的方法
    const open = () => {
      dialogVisible.value = true;
    };
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dialogVisible.value = $event),
        title: "选择加盟商",
        width: "600px",
        "append-to-body": "",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_cache[5] || (_cache[5] = _createTextVNode(" 已选择 ", -1)), _createElementVNode("span", _hoisted_14, _toDisplayString(selectedList.value.length), 1), _cache[6] || (_cache[6] = _createTextVNode(" 个加盟商 ", -1))]), _createElementVNode("div", _hoisted_15, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: _cache[2] || (_cache[2] = $event => dialogVisible.value = false)
        }, "取消"), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          onClick: handleConfirm
        }, "确定")])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_input, {
          modelValue: searchKeyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchKeyword.value = $event),
          placeholder: "搜索加盟商名称",
          clearable: "",
          onKeyup: _withKeys(handleSearch, ["enter"]),
          onClear: handleSearch
        }, {
          append: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: handleSearch
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            })], -1)]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_2, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 加载中... ")) : franchiseeList.value.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 1
        }, _renderList(franchiseeList.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.id,
            class: _normalizeClass(["p-3 border-b border-slate-100 last:border-0 hover:bg-slate-50 cursor-pointer", {
              'bg-primary-50': isSelected(item)
            }]),
            onClick: $event => toggleSelect(item)
          }, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_checkbox, {
            "model-value": isSelected(item),
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
            onChange: $event => toggleSelect(item)
          }, null, 8, ["model-value", "onChange"]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_8, [item.ownerUserName ? (_openBlock(), _createElementBlock("span", _hoisted_9, "负责人: " + _toDisplayString(item.ownerUserName), 1)) : _createCommentVNode("", true), item.statusDesc ? (_openBlock(), _createElementBlock("span", _hoisted_10, "状态: " + _toDisplayString(item.statusDesc), 1)) : _createCommentVNode("", true)])])])], 10, _hoisted_4);
        }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_11, " 暂无数据 "))])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};